<template>
	<div>
		<div class="ct_bgi">
			<img class="ctc" :src="img" alt="" />
			<div class="bj">
				<div class="bjt1">
					<div><img :src="img1" alt="" /></div>
					<div>预览图</div>
					<div><img :src="img1" alt="" /></div>
				</div>
				<div class="line"></div>
				<div v-for="(item,index) in list" :key='index'
					style="margin-top: 10px;padding-left: 10px;display: flex;align-items: center;">
					<div class="lbox">
						<div class="index1" v-if='index==0'></div>
						<div class="index2" v-if='index==1'></div>
						<div class="index3" v-if='index==2'></div>
						<div class="index4" v-if='index==3'></div>
						<div class="index5" v-if='index==4'></div>
						<div class="index6" v-if='index==5'></div>
						<div class="index7" v-if='index==6'></div>
					</div>
					<div style="color: #FBF7F9;margin-left: 10px;">{{item}}</div>
				</div>
			</div>
		</div>






	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui';
	export default {

		data() {
			return {
				img: require('../assets/ctc.png'),
				img1: require('../assets/icon.png'),
				list: ['观光台', '智能水肥一体化灌溉系统', '临时住房', '蓄水池', '办公区域', '住宿区', '仓储库房，养殖区']
			}
		},
		mounted() {},
		methods: {}
	}
</script>

<style scoped lang="less">
	.ct_bgi {
		width: 44vw;
		height: 60vh;
		background-image: url('../assets/ct.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;

		
	}

	.ctc {
		width: 420px;
		height: 530px;
		position: absolute;
		right: 40px;
		top: 30px;

	}

	.bj {
		height: 290px;
		position: absolute;
		background-image: url('../assets/ctl.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		left: 60px;
		top: 40px;




	}

	.line {
		width: 90%;
		height: 7px;
		position: absolute;
		background-image: url('../assets/line.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin-left: 10px;

	}

	.bjt1 {
		width: 260px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;

	}

	.bjt1>div:nth-of-type(1),

	.bjt1>div:nth-of-type(3) {
		width: 30px;
		height: 24px
	}

	.bjt1>div>img {
		width: 30px;
		height: 24px
	}

	.bjt1>div {
		width: 60px;
		text-align: center;
		font-family: Adobe Heiti Std;
		font-weight: normal;
		font-size: 18px;
		color: #11E5C0;
		font-weight: 600;

	}

	.lbox {
		width: 30px;
		height: 18px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.index1 {
		width: 15px;
		height: 15px;
		border-radius: 50px;
		background-color: #FF0000;
	}

	.index2 {

		width: 15px;
		height: 15px;
		border-radius: 50px;
		background-color: #1FF296;
	}

	.index3 {
		width: 21px;
		height: 14px;
		background-color: #FCFF00;
		border-radius: 2px;
	}

	.index4 {
		width: 21px;
		height: 14px;
		background-color: #6CC9F9;
		border-radius: 2px;
	}

	.index5 {
		width: 28px;
		height: 16px;
		background-image: url('../assets/icon1.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.index6 {
		width: 28px;
		height: 16px;
		background-image: url('../assets/icon2.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.index7 {
		width: 28px;
		height: 16px;
		background-image: url('../assets/icon3.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
</style>